import {EntityViewProperties} from "./EntityViewProperties";

export const RequestFeatureInfo = `
    query requestFeatureInfo  ($fullUid: String!) {
        allEntitiesviews (condition: {fullUid: $fullUid}) {
            nodes {
                stAsgeojson
                ${EntityViewProperties}
            }
        }
    }
`;
